module.exports = __webpack_public_path__ + "static/media/arched-border.806db34a.png";